/* istanbul ignore file */
import React from 'react';
import AccountsBreadcrumbs from 'domain/sales/account/shared/AccountsBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAccountUrl } from 'domain/shared/account';

const CreateAccountBreadcrumbs = () => {
  const { getCreateUrl } = useAccountUrl();

  return (
    <AccountsBreadcrumbs>
      <CreateBreadcrumbItem entity="Account" link={getCreateUrl()} />
    </AccountsBreadcrumbs>
  );
};

export default CreateAccountBreadcrumbs;
